import { ChangeBuiltInPasswords } from "@/components/instance/actions/security/ChangeBuiltInPasswords";
import { ManageToken } from "@/components/instance/actions/security/ManageToken";
import { ChangeIPWhitelist } from "@/components/instance/actions/security/ChangeIPWhiteList";
import { ChangeUsers } from "@/components/instance/actions/security/ChangeUsers";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { Button, Modal } from "antd";
import { TopBreadcrumb } from "@/layouts/TopBreadcrumb";
import { useParams } from "react-router-dom";
import { UpdateInstanceProfile } from "@/components/instance/actions/profile/UpdateInstanceProfile";
import { UpdateDomainName } from "@/components/instance/actions/profile/UpdateDomainName";

import {
  CHANGE_NODEGROUP,
  CHANGE_HADOOP,
  CHANGE_MYSQL,
  CHANGE_VIA,
  CHANGE_DOMAIN_NAME,
  CHANGE_DRUID,
  ENABLE_DRUID,
  CHANGE_GITEA,
  ENABLE_GITEA,
  CHANGE_NEO4J,
  ENABLE_NEO4J
} from "@/resources-def";
import { AddAddons } from "./addons/AddAddons";
import { EnterMaintenanceEditor } from "@/components/instance/actions/mainteinance/enter";

export const ActionPage = ({ goto }) => {
  const updateProfiles = [
    CHANGE_NODEGROUP,
    CHANGE_HADOOP,
    CHANGE_MYSQL,
    CHANGE_VIA,
    CHANGE_DRUID,
    ENABLE_DRUID,
    CHANGE_GITEA,
    ENABLE_GITEA,
    CHANGE_NEO4J,
    ENABLE_NEO4J
  ];

  const { action, id } = useParams();
  const navigate = useResourceNavigate();
  const onLaunchInstance = (e) => {
    e.preventDefault();
    navigate({ resource: goto, action: "list" });
  };

  if (action == "changeBuiltInPasswords") {
    return <ChangeBuiltInPasswords id={id} goto={goto} />;
  } if (action == "changeUsers") {
    return <ChangeUsers id={id} goto={goto}/>;
  } else if(action == "manageToken") {
    return <ManageToken id={id} goto={goto} />;
  } else if (updateProfiles.indexOf(action) != -1) {
    return (
      <UpdateInstanceProfile
        id={id}
        goto={goto}
        action={action}
      ></UpdateInstanceProfile>
    );
  } else if (action === CHANGE_DOMAIN_NAME) {
    return (
      <UpdateDomainName id={id} goto={goto} action={action}></UpdateDomainName>
    );
  } else if (action == "changeIpWhiteList") {
    return <ChangeIPWhitelist id={id} goto={goto} />;
  } else if (action == "addAddons") {
    return <AddAddons id={id} goto={goto} action={action}/>;
  } else if (action == "enableMaintenance" || action == "updateMaintenance") {
    return <EnterMaintenanceEditor id={id} goto={goto}></EnterMaintenanceEditor>
  } else {
    return (
      <div>
        <TopBreadcrumb />
        <h1>Action: {action}</h1>
        <p>InstanceId: {id}</p>
        <Button onClick={onLaunchInstance}>Cancel</Button>
      </div>
    );
  }
};
